import {Plugins, Expressions, Component} from '@packages/systems/wfdl';
import {Expression, type ExpressionElement} from '@packages/systems/wfdl-ast';
import {qualify} from '@packages/systems/wfdl-Qualified';

export const pageComponentType = qualify(
  Plugins.name('__SitePlugin'),
  Component.name('page')
);

export const getPageComponentFromComponentMap = (
  componentMap: Component.ComponentMap
): Component.ComponentType | undefined => componentMap.get(pageComponentType);

export const getPageComponentRender = (
  componentMap: Component.ComponentMap
): Expression | null => {
  const pageComponent = getPageComponentFromComponentMap(componentMap);
  return pageComponent ? Component.getRender(pageComponent) : null;
};

export const getPageComponentRootElement = (
  componentMap: Component.ComponentMap
): ExpressionElement | null => {
  const renderExpr = getPageComponentRender(componentMap);
  return renderExpr ? Expressions.getElement(renderExpr) : null;
};
